# Test mode

Test mode lets you exercise the full N4 pipeline (routing → provider call → webhook → ledger →
postback) without moving real money. Test keys route only to sandbox provider accounts; live keys
route only to production accounts. This is a **hard filter** — no cross-wire is possible.

## Getting test keys

In the operator/partner portal:

1. Go to **Configurações → Chaves de API**
2. Click **+ Nova chave**
3. Select **Modo: Test**
4. Set permissions
5. Save the `pk_*` and `sk_*` pair — secret is shown ONCE

## Sandbox test cards

N4 routes test card payments to Mercado Pago sandbox. Provider-side test cards:

| Brand | Number | CVV | Exp |
|---|---|---|---|
| Visa credit | `4235 6477 2802 5682` | `123` | `11/30` |
| Mastercard credit | `5031 4332 1540 6351` | `123` | `11/30` |
| American Express | `3753 651535 56885` | `1234` | `11/30` |
| Elo Débito | `5067 7667 8388 8311` | `123` | `11/30` |

## Forcing outcomes via holderName

The cardholder name controls MP sandbox's decision:

| holderName | Outcome |
|---|---|
| `APRO` | Approved |
| `OTHE` | General decline |
| `CONT` | Pending |
| `CALL` | Call for auth |
| `FUND` | Insufficient funds |
| `SECU` | Invalid security code |
| `EXPI` | Expired card |
| `FORM` | Invalid form data |

Example — guaranteed approval:

```json
{
  "amount": 1000,
  "paymentMethod": "credit_card",
  "installments": 1,
  "customer": {"name": "Test Buyer", "email": "t@e.com"},
  "card": {
    "number": "4235647728025682",
    "holderName": "APRO",
    "expirationMonth": 11,
    "expirationYear": 2030,
    "cvv": "123"
  }
}
```

## PIX in sandbox — known limitation

PIX QR codes generated against MP sandbox **cannot be paid** end-to-end. The EMV string doesn't
pass through the real BCB DICT, so wallets reject "Copia e Cola" as invalid. Workaround:
validate the PIX pipeline structurally (POST returns QR + expiresAt), then exercise the
post-payment flow via a card APRO smoke (webhooks + ledger + postback all behave identically).

## Boleto in sandbox

Boletos work structurally — N4 generates the boleto via MP and returns `linhaDigitavel`, `barcode`,
and `pdfUrl`. Cancelling at the buyer's bank side won't fire a webhook (sandbox quirk); use the
admin **expire boleto** action or wait for `BoletoExpiryCron` to fire 6h+ past expiresAt.

## Transfers + splits in sandbox

Both require MP Marketplace and Disbursements features enabled on the merchant's MP account
(B2B onboarding). Sandbox returns `transfer_not_enabled_on_account` (transfers) or
`The name of the following parameters is wrong : [collector_id]` (splits) until the operator
enables these features. N4-side plumbing (validation, KYC gates, mapping checks) is fully
exercisable without provider Marketplace access — only the final adapter call to MP requires it.
